import { Field } from 'formik';
import { Grid } from '@material-ui/core';

import TextFieldFormik from 'app/components/form/formik/TextFieldFormik';
import { SMLocationCreateFormFields as FormFields } from 'features/data-exchange/winch/smlocation.constants';

const CreateSMLocationForm = () => (
  <Grid container direction="column">
    <Grid item>
      <Field
        required
        autoFocus
        fullWidth
        label="Name"
        margin="normal"
        component={TextFieldFormik}
        name={FormFields.NAME}
      />
    </Grid>
  </Grid>
);

export default CreateSMLocationForm;
